import { CREW_DOMAIN_NAME } from '../../../../modules/Creator/Crew/S/constant';

export const isAllCrewDomain = (crew_domain_name: string) => crew_domain_name === CREW_DOMAIN_NAME.ALL;

export const makePlusUrl = (domain_name?: string, path = '') => {
  if (!domain_name || isAllCrewDomain(domain_name)) {
    return path;
  }

  const FALLBACK_SERVICE_URL = `http://dev.localhost:11001`;
  const url = new URL(`${process.env.SERVICE_URL || FALLBACK_SERVICE_URL}${path}`);
  url.hostname = `${domain_name}.${url.hostname}`;

  return url.toString();
};

export const makeMainUrl = (path = '') => {
  return `${process.env.SERVICE_URL}${path}`;
};

/**
 * 마플샵 도메인 검사 정규식
 */
export const marppleShopUrlRegex = new RegExp(
  `^${(process.env.SERVICE_URL || 'http://dev.localhost:11001').replace(
    /[-/\\^$*+?.()|[\]{}]/g,
    '\\$&',
  )}/.+/products/(\\d+)$`,
);

/**
 * url 에 timestamp 쿼리스트링에 넣고 반환
 */
export function makeCacheAvoidUrl(url: string): string {
  if (!url) {
    return url || '';
  }

  const hasQueryParams = url.includes('?');
  const searchParams = new URLSearchParams(hasQueryParams ? url.split('?')[1] : '');
  searchParams.set('t', Date.now().toString());

  const baseUrl = hasQueryParams ? url.split('?')[0] : url;
  return `${baseUrl}?${searchParams.toString()}`;
}
